export default __webpack_public_path__ + "static/media/0.7e8be34a.png";